import gql from "graphql-tag";

export const DeleteSustainabilityArgument = gql`
  mutation DeleteSustainabilityArgument($id: [String!]!) {
    deleteSustainabilityArguments(ids: $id)
  }
`;
